<div>
  <div class="flex items-center m-b-10">
    <span><b>Scheme History</b></span>
    <mat-icon *ngIf="hasPermissions"
              class="add-icon"
              color="primary"
              matTooltip="Add scheme history"
            (click)="onAddSchemeHistory()">add
    </mat-icon>
  </div>

  <div *ngIf="schemeHistory && schemeHistory.length > 0">
    <ul>
      <li *ngFor="let scheme of schemeHistory" class="flex items-center">
        <span class="m-r-10">{{getSchemeHistoryString(scheme)}}</span>
      <ng-container *ngIf="hasPermissions">
        <mat-icon class="edit-icon" color="primary"
                  matTooltip="Edit scheme history"
                  (click)="onEditSchemeHistory(scheme)">edit
        </mat-icon>
        <mat-icon class="edit-icon" color="primary"
                  matTooltip="Delete scheme history"
                  (click)="onDeleteSchemeHistory(scheme)">delete
        </mat-icon>
      </ng-container>
      </li>
    </ul>
  </div>
  <div *ngIf="!schemeHistory || schemeHistory.length === 0">
    <p>No scheme history found.</p>
  </div>
</div>
